<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import CaptainInboxesAPI from 'dashboard/api/captain/inboxes';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const { t } = useI18n();
const aiAutoReplyEnabled = ref(false);
const isSaving = ref(false);
const assistantId = ref(null);

onMounted(() => {
  const ci = props.inbox?.captain_inbox;
  aiAutoReplyEnabled.value = ci?.ai_auto_reply_enabled === true;
  assistantId.value = ci?.captain_assistant_id;
});

const handleSave = async () => {
  if (!assistantId.value) return;
  isSaving.value = true;
  try {
    await CaptainInboxesAPI.update({
      assistantId: assistantId.value,
      inboxId: props.inbox.id,
      aiAutoReplyEnabled: aiAutoReplyEnabled.value,
    });
    useAlert(t('AI_AGENT_SETTINGS.INBOX.SAVED'));
  } catch (error) {
    useAlert(error?.message || t('AI_AGENT_SETTINGS.INBOX.SAVE_ERROR'));
  } finally {
    isSaving.value = false;
  }
};
</script>

<template>
  <div class="mx-6 max-w-4xl flex flex-col gap-6">
    <p class="text-sm text-n-slate-11">
      {{ t('AI_AGENT_SETTINGS.INBOX.DESCRIPTION') }}
    </p>

    <label
      class="flex items-start gap-3 rounded-lg border border-n-weak bg-n-alpha-1 p-4 cursor-pointer hover:bg-n-alpha-2 transition-colors"
    >
      <input
        v-model="aiAutoReplyEnabled"
        type="checkbox"
        class="mt-0.5 h-4 w-4 cursor-pointer"
      />
      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium text-n-slate-12">
          {{ t('AI_AGENT_SETTINGS.INBOX.AUTO_REPLY_LABEL') }}
        </span>
        <span class="text-xs text-n-slate-11">
          {{ t('AI_AGENT_SETTINGS.INBOX.AUTO_REPLY_HELP') }}
        </span>
      </div>
    </label>

    <button
      type="button"
      class="self-start px-4 py-2 rounded-lg bg-n-brand text-white text-sm font-medium disabled:opacity-50"
      :disabled="isSaving"
      @click="handleSave"
    >
      {{
        isSaving
          ? t('AI_AGENT_SETTINGS.INBOX.SAVING')
          : t('AI_AGENT_SETTINGS.INBOX.SAVE_BUTTON')
      }}
    </button>
  </div>
</template>
